import { designToken, quickProperty } from '../component-tokens';
import { sizeAttributes } from './utils';
const icon = {
    alias: 'banner-icon',
    name: 'icon',
    attributes: {
        color: designToken('text-04'),
        width: quickProperty('18px'),
        'margin-right': quickProperty('10px'),
        'pointer-events': quickProperty('none'),
    },
};
const fontBase = {
    font: designToken('body-small'),
    color: designToken('text-04'),
};
const closeButton = {
    alias: 'banner-close-button',
    name: 'close',
    attributes: Object.assign(Object.assign({}, sizeAttributes('14px')), { display: quickProperty('flex'), cursor: quickProperty('pointer'), background: quickProperty('none'), border: quickProperty('none'), color: designToken('text-04'), 'margin-top': quickProperty('3px'), position: quickProperty('absolute'), 'justify-content': quickProperty('center'), 'align-items': quickProperty('center'), right: quickProperty('12px'), padding: quickProperty('0') }),
};
export const bannersTokens = {
    name: 'banner',
    tag: 'chameleon-banner',
    reactImports: 'Banner',
    attributes: Object.assign(Object.assign({}, fontBase), { 'box-sizing': quickProperty('border-box'), display: quickProperty('flex'), gap: quickProperty('8px'), 'justify-content': quickProperty('center'), 'align-items': quickProperty('center'), padding: quickProperty('8px 16px'), position: quickProperty('relative'), '--goto-icon-size': quickProperty('18px'), '--goto-icon-color': designToken('text-04') }),
    variants: [
        {
            name: 'success',
            children: [icon, closeButton],
            attributes: {
                'background-color': designToken('success-01'),
            },
        },
        {
            name: 'danger',
            attributes: {
                'background-color': designToken('danger-01'),
            },
            children: [icon, closeButton],
        },
        {
            name: 'info',
            attributes: {
                'background-color': designToken('interactive-01'),
            },
            children: [icon, closeButton],
        },
        {
            name: 'dark',
            attributes: {
                'background-color': designToken('neutral'),
            },
            children: [icon, closeButton],
        },
    ],
    children: [
        {
            name: 'link',
            attributes: Object.assign(Object.assign({}, fontBase), { 'text-decoration': quickProperty('underline'), cursor: quickProperty('pointer') }),
        },
    ],
};
